import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/scrabble.json";
import fr from "@/locales/fr/puzzle-types/scrabble.json";

export const SCRABBLE_NS = "puzzle-types/scrabble";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerScrabbleTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", SCRABBLE_NS))
    i18n.addResourceBundle("en", SCRABBLE_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", SCRABBLE_NS))
    i18n.addResourceBundle("fr", SCRABBLE_NS, fr, true, true);
}
